import { twMerge as twm } from 'tailwind-merge'

type Props = {
    isOn?: boolean
    onChange?: (newIsOn: boolean) => void
    className?: string
}

export const Switch = ({ isOn = false, onChange = () => {}, className }: Props) => {
    return (
        <button
            className={twm(
                'bg-secondary-400 flex w-[56px] items-center justify-start rounded-full p-1',
                isOn
                    ? 'bg-secondary-400 justify-end'
                    : 'justify-start bg-gray-400 hover:bg-gray-500',
                className
            )}
            onClick={() => onChange(!isOn)}
        >
            <div className="size-[24px] rounded-full bg-white" />
        </button>
    )
}
